import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { CreateTread, Notification, Drawer } from 'components';
import { ReactComponent as House } from 'assets/svg/home-line.svg';
import { ReactComponent as Logo } from 'assets/svg/treadie-logo-4.svg';
import { ReactComponent as NotificationSvg } from 'assets/svg/notification-line.svg';
import { ReactComponent as AddSvg } from 'assets/svg/add-line.svg';
// import { ReactComponent as MembersSvg } from 'assets/svg/members-line.svg';
import { ReactComponent as CommentSvg } from 'assets/svg/comment-line.svg';
import { ReactComponent as ArrowLeftSvg } from 'assets/svg/arrow-left.svg';
// import { Drawer } from './drawer';

export const Wrapper = props => {
  const [drawer, setDrawer] = useState(false);
  const [createtread, setTread] = useState(false);
  const [notification, setNotification] = useState(false);

  const toggleDrawer = () => setDrawer(!drawer);

  return (
    <div className="wrapper">
      <main className="wrapper__main">
        {/* <div className="wrapper__overlay"></div> */}
        <div className="wrapper__nav wrapper__nav--mb">
          {props.loggedIn ? (
            <>
              {props.showHeader ? (
                <>
                  <div className="wrapper__header">
                    <a href="#">
                      <ArrowLeftSvg
                        style={{
                          width: '20px',
                          height: '20px',
                          marginRight: '40px',
                          cursor: 'pointer'
                        }}
                      />
                    </a>

                    {props.showProfileImage ? (
                      <div className="wrapper__header__avatar wrapper__header__profile-avatar">
                        <img src="https://picsum.photos/200" alt="" />
                      </div>
                    ) : null}
                    <div className="wrapper__header__user">
                      <h3 className="wrapper__header__title">{props.title}</h3>
                      <h3 className="wrapper__header__subtitle thread__sub-item">
                        <div>{props.subtitle}</div>
                        {props.showProfileImage ? (
                          <div>{props.subtreads}</div>
                        ) : null}
                      </h3>
                    </div>
                  </div>
                  <>
                    {props.showTread ? (
                      <>
                        <Link
                          className="wrapper__header__icon show-for-medium-only"
                          to="/"
                        >
                          <img src="https://picsum.photos/200" alt="" />
                        </Link>

                        <Link
                          className="wrapper__header__icon show-for-medium-only"
                          to=""
                        >
                          <CommentSvg width={20} height={20} />
                        </Link>

                        {/*<Link
                          className="wrapper__header__icon show-for-medium-only"
                          to=""
                        >
                          <MembersSvg width={20} height={20} />
                    </Link> */}
                      </>
                    ) : null}
                  </>
                </>
              ) : (
                <>
                  <Link className="wrapper__header__icon active" to="/">
                    <House width={20} height={20} />
                  </Link>

                  <a
                    className="wrapper__header__icon"
                    href="#"
                    onClick={() => setTread(!createtread)}
                  >
                    <AddSvg width={20} height={20} />
                  </a>

                  <a
                    className="wrapper__header__icon"
                    href="#"
                    onClick={() => setNotification(!notification)}
                  >
                    <NotificationSvg width={20} height={20} />
                  </a>

                  <div
                    onClick={toggleDrawer}
                    className="wrapper__header__avatar active"
                  >
                    <img src="https://picsum.photos/200" alt="Avatar" />
                  </div>
                </>
              )}
            </>
          ) : (
            <>
              <Link
                className="wrapper__header__icon site-home top-bar-title"
                to="/"
              >
                <div className="">
                  <Logo width={20} height={20} />
                  <strong className="" style={{ marginLeft: '10px' }}>
                    Treadie
                  </strong>
                </div>
              </Link>
              <Link
                to="/login"
                className="button button__join button__join__mt"
              >
                Join
                <span className="button__join__below">Or Login</span>
              </Link>
            </>
          )}
        </div>
        <div className="wrapper__nav wrapper__nav--dp">
          <div className="wrapper__header">
            {props.showHeader ? (
              <a href="#">
                <ArrowLeftSvg
                  style={{
                    width: '20px',
                    height: '20px',
                    marginRight: '40px',
                    cursor: 'pointer'
                  }}
                />
              </a>
            ) : null}
            {props.showProfileImage ? (
              <div className="wrapper__header__avatar wrapper__header__profile-avatar">
                <img src="https://picsum.photos/200" alt="" />
              </div>
            ) : null}
            <div className="wrapper__header__user">
              <h3 className="wrapper__header__title">{props.title}</h3>
              <h3 className="wrapper__header__subtitle thread__sub-item">
                <div>{props.subtitle}</div>
                {props.showProfileImage ? <div>{props.subtreads}</div> : null}
              </h3>
            </div>
          </div>
          {props.showTread ? (
            <>
              <Link className="wrapper__header__icon" to="/">
                <img src="https://picsum.photos/200" alt="" />
              </Link>

              <Link className="wrapper__header__icon" to="">
                <CommentSvg width={20} height={20} />
              </Link>

              {/* <Link className="wrapper__header__icon" to="">
                <MembersSvg width={20} height={20} />
          </Link> */}
            </>
          ) : null}
        </div>
        <div
          className={
            props.showMb
              ? 'wrapper__content wrapper__content--mb'
              : 'wrapper__content'
          }
        >
          {props.children}
        </div>
      </main>
      <aside className="wrapper__side">
        <div className="wrapper__nav  wrapper__nav--dp">
          {props.loggedIn ? (
            <>
              <Link className="wrapper__header__icon active" to="/">
                <House width={20} height={20} />
              </Link>

              <a
                className="wrapper__header__icon"
                href="#"
                onClick={() => setTread(!createtread)}
              >
                <AddSvg width={20} height={20} />
              </a>

              <a
                className="wrapper__header__icon"
                href="#"
                onClick={() => setNotification(!notification)}
              >
                <NotificationSvg width={20} height={20} />
              </a>

              <div
                onClick={toggleDrawer}
                className="wrapper__header__avatar active"
              >
                <img src="https://picsum.photos/200" alt="Avatar" />
              </div>
            </>
          ) : (
            <>
              <Link className="wrapper__header__icon" to="/">
                <Logo width={20} height={20} />
              </Link>
            </>
          )}
        </div>
        <div className="wrapper__content">{props.side}</div>
      </aside>

      <Drawer active={drawer} />
      <CreateTread
        show={createtread}
        toggle={() => setTread(!createtread)}
        start
      />
      <Notification
        show={notification}
        toggle={() => setNotification(!notification)}
      />
    </div>
  );
};

Wrapper.propTypes = {
  loggedIn: PropTypes.bool,
  showProfileImage: PropTypes.bool,
  showHeader: PropTypes.bool,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  subtreads: PropTypes.string,
  side: PropTypes.node,
  showTread: PropTypes.bool,
  showMb: PropTypes.bool
};
